import {
  NET_PREMIUM_DATA_REQUEST,
  NET_PREMIUM_DATA_SUCCESS,
  NET_PREMIUM_DATA_FAIL,
} from '../constants/dispOfNetPremiumConstant';

export const dispOfNetPremiumReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case NET_PREMIUM_DATA_REQUEST:
      return { loading: true, formData: [] };
    case NET_PREMIUM_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case NET_PREMIUM_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
